<style lang="stylus">
/* ----- Base header ----- */
.secondaryheader, .secondary-header
  a
    color: #000
    padding: 5px
    font-size: 14px
    font-weight: 500
    letter-spacing: 0.6px

    img
      height: 23px
      width: 23px
      vertical-align: middle

/* Icons/images inside Vuetify components */
.v-btn img, .v-list img
  height: 24px
  width: 24px

/* Toolbar look/behavior (V3) */
.v-toolbar
  background-color: #fff !important
  color: #000 !important
  -webkit-box-shadow: unset
  box-shadow: unset
  overflow: visible   // keep pseudo-underline from being clipped

/* Buttons: keep text case as-is */
.v-btn
  text-transform: none !important

/* Tables (unchanged) */
td[class*='vs-table'], div[class*='vs-table']
  font-size: 14px

/* Optional badge */
.yellowLabel
  background-color: #fec626
  padding: 10px
  margin-left: 20px

/* Dropdown list for menu (V3 classes) */
.dropped-item
  padding: 1px
  background: #fff !important
  cursor: pointer
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important

  .v-list-item-title
    min-height: 0

  &:hover
    color: #8C1D40 !important
    text-decoration: underline

/* ===== Underline animation for navbar v-btns (V3-safe) ===== */

/* Remove Vuetify's hover overlay tint so only our underline animates */
.v-btn--variant-text .v-btn__overlay,
.v-btn--variant-plain .v-btn__overlay
  opacity: 0 !important
  background: transparent !important

/* Button used in navbar */
.login-nav-item
  display: inline-block
  color: #000
  text-decoration: none
  padding-right: 4px
  padding-left: 4px
  min-width: 0
  font: normal normal normal 16px/22px Arial !important
  position: relative
  padding-bottom: 8px         // space for underline inside button
  border-bottom: 0 !important // avoid layout shift

  /* Make sure our pseudo sits above overlay */
  .v-btn__content
    position: relative

    &::after
      content: ''
      position: absolute
      left: 0
      right: 0
      bottom: -8px
      height: 8px
      background: #fec832
      transform: scaleX(0)
      transform-origin: left
      transition: transform 0.3s ease
      pointer-events: none
      z-index: 1

  &:hover
    .v-btn__content::after
      transform: scaleX(1)

/* If any instance still shows overlay tint, hard-disable per-button */
.login-nav-item .v-btn__overlay
  opacity: 0 !important
  background: transparent !important

/* ---- Right-aligned login/register buttons container ---- */
.login-buttons-container
  position: absolute
  right: 0
  top: 55%
  transform: translateY(-50%)
  display: flex
  align-items: center

/* Responsive nudges */
@media (max-width: 1400px)
  .login-buttons-container
    right: 16px

@media (max-width: 1200px)
  .login-buttons-container
    right: 32px

@media (max-width: 1024px)
  .login-buttons-container
    right: 48px
</style>

<template>
  <div class="secondaryheader">
    <v-toolbar class="container" style="padding: 0; position: relative">
      <v-toolbar-items class="d-none d-sm-flex">
        <div v-for="(item, index) in loggedOutNavBarMenu" :key="index">
          <v-btn
            variant="text"
            class="px-2"
            style="border-bottom: 8px solid #ffc627; min-width: 0; margin-bottom: -36px"
            @click="
              navigateToLogin();
              asuoDataLayerClick('LoggedOutSecondaryheader', '0', '');
            "
            v-if="item.htmlLink.text === 'Home'"
          >
            <a style="color: #191919">
              <v-icon class="pt-3 mb-2" style="font-size: 20px">mdi-home</v-icon>
            </a>
          </v-btn>
          <v-menu open-on-hover offset-y v-else-if="hasChildren(item)" :rounded="'0'">
            <template v-slot:activator="{ props }">
              <v-btn
                @click="handleCollapseShowHide(item)"
                v-bind="props"
                variant="text"
                :ripple="false"
                class="login-nav-item"
                style="margin-bottom: -50px"
              >
                <span>
                  {{ item.htmlLink.text }} <v-icon class="ml-2" style="font-size: 14px">mdi-chevron-down</v-icon>
                </span>
              </v-btn>
            </template>
            <div>
              <!-- <div v-for="(child, index) in item.children" :key="index"> -->
              <v-list
                v-for="(child, childIndex) in item.children"
                :key="childIndex"
                class="dropped-item font-weight-bold text-left"
              >
                <v-list-item>
                  <v-list-item-title @click="openLink(child)">{{ child.htmlLink.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <!-- </div> -->
            </div>
          </v-menu>
          <v-btn
            v-else
            :href="item.htmlLink.uri"
            :target="item.htmlLink.target"
            variant="text"
            :ripple="false"
            class="login-nav-item"
            style="margin-bottom: -45px"
            @click="asuoDataLayerClick('LoggedOutSecondaryheader', item.dataLayerIndex, '')"
          >
            <span>{{ item.htmlLink.text }}</span>
          </v-btn>
        </div>
      </v-toolbar-items>
      <div v-if="!isLoggedin" class="login-buttons-container d-none d-md-flex">
        <v-btn
          @click="
            login();
            asuoDataLayerClick('SecondaryHeaderComponent', '6', {
              text: 'login'
            });
          "
          variant="elevated"
          style="background: #8c1d40; border-radius: 25px; height: 32px; margin-right: 8px; max-width: 90px"
        >
          <a style="color: #fff; font-weight: 600">Login</a>
        </v-btn>
        <v-btn
          v-if="isEligibleForSignUp"
          @click="handleRegisterClick"
          variant="elevated"
          style="background: #ffc627; border-radius: 25px; height: 32px; max-width: 90px"
        >
          <a style="font-weight: 600">Register</a>
        </v-btn>
      </div>
    </v-toolbar>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';
import { useAuthStore } from '@/stores/auth';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { Logger } from '../mixins/logger.js';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { Helper } from '../mixins/helpers';

export default defineComponent({
  name: 'LoginSecondaryHeaderComponent',

  props: {
    step: {
      type: Number
    },
    loggedOutNavBarMenu: {
      type: Array
    }
  },

  mixins: [Helper, DataLayerMixin, Logger, AjaxLoader],

  methods: {
    login() {
      // this.logInfo('calling asurite');
      //
      // this.$auth.login('asurite');
      //

      this.$router.push('/');
    },

    navigateToHelp() {
      window.open(
        Helper.methods.isUlcPartner()
          ? 'https://ulc.asu.edu/help-center/faqs/'
          : 'https://ea.asu.edu/help-center/faqs/',
        '_blank'
      );
    },

    navigateToLogin() {
      if (this.$router.currentRoute.path !== '/') this.$router.push('/');
    },

    hasChildren(item) {
      return item.children && item.children.length > 0;
    },
    handleCollapseShowHide(item) {
      item.isActive = !item.isActive;
      item.isActive &&
        this.asuoDataLayerClick('LoggedOutSecondaryheader', '18', {
          text: item.htmlLink.text
        });
    },
    openLink(item) {
      this.asuoDataLayerClick('LoggedOutSecondaryheader', item.dataLayerIndex, {
        text: item.htmlLink.text
      });
      this.resetItems();

      window.open(item.htmlLink.uri, item.htmlLink.target || '_blank');
    },
    resetItems() {
      this.loggedOutNavBarMenu.forEach((item) => {
        item.isActive = false;
      });
    },
    register() {
      this.$router.push({ name: 'Registerv2' });
    },

    handleRegisterClick() {
      this.register();
      this.asuoDataLayerClick('SecondaryHeaderComponent', '6', {
        text: 'register'
      });
    },

    manualRegisterHandler(event) {
      event.preventDefault();
      event.stopPropagation();
      this.handleRegisterClick();
    }
  },

  computed: {
    isLoggedin: function () {
      // Use both store state (for reactivity) and AuthManager service (for accuracy)
      const authStore = useAuthStore();
      return authStore.isAuthenticated && this.$auth && this.$auth.isAuthenticated();
    },
    isEligibleForSignUp: function () {
      const userStore = useUserStore();
      // Add null-safe operators and better reactivity
      return userStore?.welcomePageData?.isEligibleForSignUp || false;
    }
  },

  watch: {
    isEligibleForSignUp(newVal) {
      this.$forceUpdate();

      // Add manual event listener when button becomes visible
      if (newVal === true) {
        this.$nextTick(() => {
          const registerButtons = this.$el.querySelectorAll('button');
          registerButtons.forEach((btn) => {
            if (btn.textContent && btn.textContent.includes('Register')) {
              btn.removeEventListener('click', this.manualRegisterHandler);
              btn.addEventListener('click', this.manualRegisterHandler);
            }
          });
        });
      }
    }
  }
});
</script>
